import { WorkspacesSidebar as Sidebar } from '@carboncopyco/components';
import { useGetWorkspacesQuery } from '@carboncopyco/data';
import { useCustomNavigate } from '../../../hooks/useCustomNavigate';
import { useUser, useWorkspaces } from '../../../store/context';
import { SidebarContentType } from '../../../types/WorkspacesTypes';
import { WelcomeScreenButton } from './WelcomeScreenButton';

import { useLocation } from 'react-router-dom';

export const WorkspacesSidebar = () => {
  const { activeOrganization } = useUser();
  const { activeSidebarType } = useWorkspaces();
  const { data: workspaces } = useGetWorkspacesQuery({
    organizationId: activeOrganization?.id.toString(),
  });
  const { activeWorkspace, switchWorkspace } = useWorkspaces();
  const {
    navigateToHomepage,
    navigateToWorkspace,
    navigateToWorkspaces,
    navigateToDashboard,
    links,
  } = useCustomNavigate();

  const handleSwitchWorkspace = (workspace: any) => {
    const ws = workspaces?.find((w) => w.id === workspace);
    switchWorkspace(ws ?? null);
    navigateToWorkspace(ws?.id);
  };
  const { pathname } = useLocation();

  return (
    <div className="bg-ds-accent3-100 flex flex-col">
      <div
        className="w-ds-15 border-b h-ds-15 border-r flex justify-center items-center self-stretch"
        data-testid="dashboardButtonWrapper"
      >
        <WelcomeScreenButton
          isSelected={activeSidebarType === SidebarContentType.Home}
          onClick={() => {
            switchWorkspace(null, SidebarContentType.Home);
            navigateToHomepage();
          }}
        />
      </div>
      <div className="flex flex-grow flex-shrink basis-0">
        <Sidebar
          isInAllWorkspaces={pathname.includes(links.getAllWorkspacesLink())}
          navigateToAllWorkspaces={() => {
            switchWorkspace(null, SidebarContentType.MyWorkspaces);
            navigateToWorkspaces();
          }}
          workspaces={workspaces || []}
          selectedWorkspace={activeWorkspace.current.id}
          switchWorkspace={handleSwitchWorkspace}
          navigateToDashboard={navigateToDashboard}
          isInDashboard={pathname.includes('dashboard')}
        />
      </div>
    </div>
  );
};
